"use client"

import { useState, useEffect, useRef } from "react"
import "./SolutionsSection.css"
import { Link } from "react-router-dom"

const numbers = [
  { num: "+20", text: "INDUSTRY SECTORS" },
  { num: "78", text: "CUSTOMER NPS SCORE" },
  { num: "99%", text: "RECOMMENDATION RATE" },
  { num: "+300", text: "PROJECTS DELIVERED" },
]

const cards = [
  {
    id: 1,
    img: "/icons/web.png", // Replace with actual icons
    title: "Web Applications",
  },
  {
    id: 2,
    img: "/icons/mobile.png", // Replace with actual icons
    title: "MOBILE APPS",
  },
  {
    id: 3,
    img: "/icons/saas.png", // Replace with actual icons
    title: "SOFTWARE AS A SERVICE(SAAS)",
  },
  {
    id: 4,
    img: "/icons/e-commerce.png", // Replace with actual icons
    title: "E-COMMERCE PLATFORMS",
  },
  {
    id: 5,
    img: "/icons/ui.webp", // Replace with actual icons
    title: "UX/UI DESIGN",
  },
  {
    id: 6,
    img: "/icons/market.png", // Replace with actual icons
    title: "MARKETPLACES",
  },
  {
    id: 7,
    img: "/icons/bussiness.png", // Replace with actual icons
    title: "BUSINESS WEBSITES",
  },
  {
    id: 8,
    img: "/icons/cms.png", // Replace with actual icons
    title: "CONTENT MANAGEMENT WEBSITES(CMS)",
  },
  {
    id: 9,
    img: "/icons/api.webp", // Replace with actual icons
    title: "API DEVELOPMENT",
  },
  {
    id: 10,
    img: "/icons/custom.webp", // Replace with actual icons
    title: "CUSTOM SOFTWARE",
  },
  {
    id: 11,
    img: "/icons/cloud.webp", // Replace with actual icons
    title: "CLOUD-BASED APP DEVELOPMENT",
  },
  {
    id: 12,
    img: "/icons/enterprise.webp", // Replace with actual icons
    title: "ENTERPRISE SOFTWARE",
  },
  {
    id: 13,
    img: "/icons/ml.webp", // Replace with actual icons
    title: "MACHINE LEARNING AND ARTIFICIAL INTELLIGENCE",
  },
]

const SolutionsSection = (props) => {
  const [active, setActive] = useState("solution")
  const cardRefs = useRef([])
  const headingRef = useRef(null)
  const paraRef = useRef(null)
  const descRef = useRef(null)

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible1")
            observer.unobserve(entry.target)
          }
        })
      },
      { threshold: 0.2 },
    )
    ;[...cardRefs.current, headingRef.current, paraRef.current, descRef.current].forEach((ref) => {
      if (ref) observer.observe(ref)
    })

    return () => observer.disconnect()
  }, [])

  // Add scroll detection for navbar highlighting
  useEffect(() => {
    const handleScroll = () => {
      const sections = ["solution", "components", "benefits", "team", "tech-stack", "faq", "contact-us"]
      const scrollPosition = window.scrollY + 200 // Offset for navbar height

      for (let i = sections.length - 1; i >= 0; i--) {
        const section = document.getElementById(sections[i])
        if (section && section.offsetTop <= scrollPosition) {
          setActive(sections[i])
          break
        }
      }
    }

    window.addEventListener("scroll", handleScroll)
    handleScroll() // Call once to set initial state

    return () => window.removeEventListener("scroll", handleScroll)
  }, [])

  const handleClick = (id) => {
    setActive(id)
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" })
  }

  return (
    <>
    <div className="solutions1-navbar">
        <div className="container">
          <ul>
            {["solution", "components", "benefits", "team", "tech-stack", "faq", "contact-us"].map((item) => (
              <li key={item}>
                <a onClick={() => handleClick(item)} className={active === item ? "active" : ""}>
                  {item.toUpperCase().replace("_", " ")}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    
    <section className="solutions1-section" id="solution">
      
      <div className="content">
        <div className="numbers-row1">
          {numbers.map((n) => (
            <div key={n.num} className="number-block1">
              <div className="big-num1">{n.num}</div>
              <div className="num-text1">{n.text}</div>
            </div>
          ))}
        </div>
        <div className="solutions-header1">
          <h2 ref={headingRef} className="fade-in-left1">
            OUR <span className="blue">SOLUTIONS</span>
          </h2>
          <p className="solutions-intro1 fade-in-right1" ref={paraRef}>
            {props.para1}
          </p>
        </div>
        <p className="solutions-description1 fade-in-left1" ref={descRef}>
          {props.para2}
        </p>
        <div className="solutions-cards1">
          {cards.map((card, idx) => (
            <div key={card.id} className="solution-card1 fade-up1" ref={(el) => (cardRefs.current[idx] = el)}>
              <img src={card.img || "/placeholder.svg"} alt="icon" className="card4-icon" />
              <h3>{card.title}</h3>
            </div>
          ))}
        </div>
      </div>
      <div className="down-btn1">
        <Link to="/industries">
          <button>SEE INDUSTRIES WE WORK IN</button>
        </Link>
      </div>
    </section>
     </>
  )
 
}


export default SolutionsSection
